import React from 'react';
import { DocumentPage } from './DocumentPage';
import { VariablesProvider } from '../variables/variablesContext/VariablesContext';
import { Links } from 'application/constants/links';

export const DocumentRootPage: React.FC = () => {
  const createDocumentMatch = Links.Authorized.CreateDocument.useMatch();
  const openDocumentMatch = Links.Authorized.OpenDocument.useMatch();

  const projectId =
    createDocumentMatch?.params.projectId ??
    openDocumentMatch?.params.projectId;
  const revisionId =
    createDocumentMatch?.params.releaseId ??
    openDocumentMatch?.params.releaseId;

  return (
    <VariablesProvider
      key={`${projectId}-${revisionId}`}
      projectId={projectId}
      revisionId={revisionId}
    >
      <DocumentPage />
    </VariablesProvider>
  );
};
